/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconCreativeCommonsZero = createReactComponent("outline", "creative-commons-zero", "IconCreativeCommonsZero", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M12 12m-3 0a3 4 0 1 0 6 0a3 4 0 1 0 -6 0", "key": "svg-1" }], ["path", { "d": "M14 9l-4 6", "key": "svg-2" }]]);

export { IconCreativeCommonsZero as default };
//# sourceMappingURL=IconCreativeCommonsZero.mjs.map
